/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Matches a route against a path and replace params with legacy params
 */

import { matchPath as reactRouterMatchPath } from 'react-router-dom'
import type { ZumperRoute, match } from './types'

export const matchPath = <
  Params extends { [K in keyof Params]?: string | undefined } = {},
>(
  pathname: string,
  route: ZumperRoute<Params> | string
): match<Params> | null => {
  const match = reactRouterMatchPath<Params>(pathname, route)
  if (
    match &&
    typeof route !== 'string' &&
    !!route.handle &&
    !!route.handle.getLegacyParams
  ) {
    match.params = route.handle.getLegacyParams(pathname)
  }
  return match
}
